import { Row } from "@/components/General/Grid/row.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export type BonusCardBalanceProps = {
    innerHTML: string;
    bonusCardNumber: string | null;
    bonusCardBalance: number | null;
    isLoading: boolean;
};

const BonusCardBalance = ({
    bonusCardNumber,
    bonusCardBalance,
    isLoading,
    innerHTML
}: BonusCardBalanceProps) => {
    const { t } = useGranite();

    return (
        <div className={bonusCardNumber === null ? "d-none mb-5" : "mb-5"}>
            <div dangerouslySetInnerHTML={{ __html: innerHTML }} />
            <Row>
                <div className="col-6">
                    <p>
                        {t("account.bonusCard.balance.label")}
                        <span className="text-danger font-weight-bold">
                            {bonusCardBalance !== null &&
                                !isLoading &&
                                bonusCardBalance}
                        </span>
                    </p>
                </div>
            </Row>
        </div>
    );
};

export default BonusCardBalance;
